import { Tab as HeadlessTab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react'
// import * as motion from 'motion/react-client'

export default function Tabs({ tabs }) {
    return (
        <div className='w-full'>
            <TabGroup>
                <TabList className='flex gap-4'>
                    {tabs.map(({ name }) => (
                        <HeadlessTab
                            key={name}
                            className={({ selected }) =>
                                `rounded-full px-3 py-1 text-sm font-semibold transition ${
                                    selected
                                        ? 'bg-yellow-100 text-yellow-700'
                                        : 'text-gray-600 hover:bg-gray-100'
                                }`
                            }
                        >
                            {name}
                        </HeadlessTab>
                    ))}
                </TabList>

                <TabPanels className='mt-4'>
                    {tabs.map(({ name, items = [] }) => (
                        <TabPanel key={name} className='p-4 bg-white border shadow rounded-xl'>
                            <ul className='space-y-3'>
                                {items.map((item, idx) => (
                                    // <motion.li
                                    <li
                                        key={idx}
                                        // whileHover={{ scale: 1.02, backgroundColor: '#eff6ff' }}
                                        // transition={{ duration: 0.2 }}
                                        className='relative p-3 transition rounded-md group hover:shadow-md hover:bg-yellow-50 hover:cursor-pointer'
                                    >
                                        <a
                                            href={item.href || '#'}
                                            className='font-medium text-gray-800 transition group-hover:text-yellow-700'
                                        >
                                            {item.title}
                                        </a>

                                        {/* Optional description */}
                                        {item.description && (
                                            <div className='mt-1 text-sm text-gray-600'>
                                                {typeof item.description === 'function'
                                                    ? item.description()
                                                    : item.description}
                                            </div>
                                        )}

                                        {/* Optional meta */}
                                        {item.meta?.length > 0 && (
                                            <div className='flex flex-wrap items-center mt-2 text-xs text-gray-500 gap-x-2 gap-y-1'>
                                                {item.meta.map((metaItem, metaIdx) => (
                                                    <span
                                                        key={metaIdx}
                                                        className='flex items-center gap-2'
                                                    >
                                                        {metaItem}
                                                        {metaIdx < item.meta.length - 1 && (
                                                            <span className='text-gray-300'>·</span>
                                                        )}
                                                    </span>
                                                ))}
                                            </div>
                                        )}
                                        {/* </motion.li> */}
                                    </li>
                                ))}
                            </ul>
                        </TabPanel>
                    ))}
                </TabPanels>
            </TabGroup>
        </div>
    )
}
